// extracted by mini-css-extract-plugin
export var singleBlog = "post-module--singleBlog--tUYAq";
export var postCategory = "post-module--postCategory--XPPiR";
export var postDate = "post-module--postDate--V8Qp+";
export var postWrapper = "post-module--postWrapper--iD94t";
export var inner = "post-module--inner--XnP2m";
export var latestPosts = "post-module--latestPosts--0uALd";
export var postItem = "post-module--postItem--S4MTW";